import { useAuthState } from '@/app/providers/auth'
import { getDeliveryDetailsForMixpanel, useMixPanel } from '@/helpers/mixpanelConfig'
import { SPLITS, useFeatureFlag } from '@/helpers/useFeatureFlag'
import useTenant from '@/hooks/useTenant'

import { useCallback } from 'react'

import type { UserBasketSettings } from '../../common/domain/user-basket-settings'

interface BasketCreatedEventParams {
  vendor: {
    id: string
    companyName: string
    isPantry: boolean | null
  }
  orderSettings: UserBasketSettings
  isCateringTeamOrder?: boolean
}

export const useMixpanelBasketCreated = () => {
  const mixPanel = useMixPanel()
  const tenant = useTenant()
  const authState = useAuthState()
  const mixPanelIndividualEvents = useFeatureFlag(SPLITS.MIX_PANEL_INDIVIDUAL_EVENTS)

  const trackBasketCreated = useCallback(
    ({ vendor, orderSettings, isCateringTeamOrder }: BasketCreatedEventParams) => {
      if (!mixPanelIndividualEvents || !vendor) return

      try {
        const deliveryDetails = getDeliveryDetailsForMixpanel(orderSettings)
        mixPanel?.track('Basket Created Marketplace', {
          name: 'Basket Created Marketplace',
          ...deliveryDetails,
          supplierType: vendor.isPantry ? 'Pantry' : 'Catering',
          address: orderSettings.location,
          customerAccount:
            authState.type === 'authenticated'
              ? `${authState.user?.id}-${authState.user.account?.name}`
              : 'guest',
          date: orderSettings.date,
          headCount: orderSettings.headCount,
          tenant: tenant?.name,
          vendor: vendor.companyName,
          vendorId: vendor.id,
          teamOrder: Boolean(isCateringTeamOrder),
        })
      } catch (e) {
        console.error('Mixpanel tracking failed', e)
      }
    },
    [mixPanelIndividualEvents, mixPanel, authState, tenant],
  )

  return { trackBasketCreated }
}
